import { UseLocationModalResult, useLocationModal } from "../../hooks/useLocationModal.ts"

export function useShareMoneyflowModal(): UseLocationModalResult {
    return useLocationModal('moneyflow-share')
}
